import { jsx as _jsx } from "react/jsx-runtime";
import { getAdvanceBookingPeriodForFilm, NotificationType } from '@vista/omnichannel-components-domain';
import { observer } from 'mobx-react';
import { useFilmContext } from '../../../context/film/hooks/use-film-context';
import { getIdForComponentNotification } from '../../../utils/get-id-for-component-notification';
import { withComponentWrapper } from '../../../utils/with-component-wrapper';
import { FilmAdvanceBookingPeriodNotificationUI } from './subcomponents/ui';
import { defaultFilmAdvanceBookingPeriodNotificationProps, filmAdvanceBookingPeriodNotificationValidator } from './types/props';
export const FilmAdvanceBookingPeriodNotification = observer(props => {
    const { filmId, filmAvailability } = useFilmContext();
    if (!filmAvailability)
        return null;
    const bookingPeriod = getAdvanceBookingPeriodForFilm(filmId);
    return (_jsx(FilmAdvanceBookingPeriodNotificationUI, Object.assign({}, props, { id: getIdForComponentNotification('film-advance-booking-period-notification', NotificationType.Error, filmId), bookingPeriod: bookingPeriod })));
});
FilmAdvanceBookingPeriodNotification.displayName = 'FilmAdvanceBookingPeriodNotification';
/**
 * The **Film Advance Booking Period Notification** component renders a notification with advance booking period information.
 *
 * If there is no advance booking period information to show then the **Film Advance Booking Period Notification** component will not render.
 */
export const FilmAdvanceBookingPeriodNotificationComponent = withComponentWrapper(FilmAdvanceBookingPeriodNotification, defaultFilmAdvanceBookingPeriodNotificationProps, filmAdvanceBookingPeriodNotificationValidator);
